import AdminFeatureFlagsPage from '../../../components/admin/settings/AdminFeatureFlagsPage'

export default function SettingsFeatureFlags() {
  return <AdminFeatureFlagsPage />
}
